"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioWidget = void 0;
const Widget_1 = require("../../core/render/Widget");
class AudioWidget extends Widget_1.Widget {
    constructor() {
        super();
        this.audio = document.createElement("audio");
        this.renderBody = this.audio;
        this.audio.controls = true;
    }
    get src() {
        return this.audio.src;
    }
    get srcObject() {
        return this.audio.srcObject;
    }
    set src(value) {
        this.audio.src = value;
    }
    set srcObject(value) {
        this.audio.srcObject = value;
    }
    play() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.audio.play();
        });
    }
    load() {
        this.audio.load();
    }
    shouldRender() {
        return true;
    }
}
exports.AudioWidget = AudioWidget;
//# sourceMappingURL=AudioWidget.js.map